module.exports = __webpack_public_path__ + "static/media/Article2.8eaceb76.png";